import { Resource as i, API as s } from "@coveo/platform-client";
const e = class e extends i {
  getLicenseRestricted() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/license/restricted`)
    );
  }
  getAvailableStatementDetails() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/definition/statementdetails`)
    );
  }
  getAvailableModifierTemplates() {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/definition/modifiertemplates`)
    );
  }
};
e.baseUrl = `/rest/organizations/${s.orgPlaceholder}`;
let t = e;
export {
  t as OrganizationSettingsResource
};
//# sourceMappingURL=OrganizationSettingsResource.js.map
